import { useState, useCallback } from 'react';
import axios from 'axios';
import AdminDigitalAssets from 'components/admin/AdminDigitalAssets';
import AdminNotesFilter from 'components/admin/AdminNotesFilter';
import connected from 'connected';

const AdminDigitalAssetsPage = () => {
    const [assets, setAssets] = useState([]);

    const onSubmit = useCallback(async (payload) => {
        try {
            const response = await axios.post('/api/admin/digital-assets', payload);
            setAssets(response.data);
        } catch (error) {
            console.error('Error fetching digital assets:', error);
        }
    }, []);

    return (
        <div className="admin-assets-page">
            <AdminNotesFilter onSubmit={onSubmit} showCountry />
            <AdminDigitalAssets assets={assets} setAssets={setAssets} />
        </div>
    );
};

export default connected(AdminDigitalAssetsPage);